module.exports = __webpack_public_path__ + "static/media/mail.db339d25.svg";